module.exports = __webpack_public_path__ + "static/media/gray-arrow-down.4ab3d50d.svg";